import { styled } from '@mui/material/styles';

export const PaywallSniperWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	width: 100vw;
	background-color: #000;
	color: #fff;
`;

export const LoadingText = styled('div')`
	flex: 1;
`;

export const ContentWrapper = styled('div')`
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	max-width: 900px;
	line-height: 1.6;
`;

export const LabelWrapper = styled('div')`
	padding-right: 1rem;
`;

export const InputWrapper = styled('div')`
	padding-top: 2rem;
	padding-bottom: 2rem;
`;

export const InputSection = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const ArticleWrapper = styled('div')`
	align-items: flex-start;
	justify-content: flex-start;
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 3rem;
	padding-bottom: 1rem;
`;

export const ArticlePara = styled('div')`
	/* Ensure each paragraph is a block with visible spacing */
	display: block;
	margin-bottom: 1rem;
	/* Preserve any internal newlines within a paragraph */
	white-space: pre-wrap;
`;
